<template>
<div class="modal-mask-home background-melody">
    <div class="modal-wrapper-home">
        <div class="elements-melody">
            <img id="bigcloud-melody" :src="require('@/assets/congrats/melody-elements/bigcloud.svg')" />
            <img id="downStarFill-melody" :src="require('@/assets/congrats/melody-elements/downStarFill.svg')" />
            <img id="mediumcloud-melody" :src="require('@/assets/congrats/melody-elements/mediumcloud.svg')" />
            <img id="smallcloud-melody" :src="require('@/assets/congrats/melody-elements/smallcloud.svg')" />
            <img id="star-melody" :src="require('@/assets/congrats/melody-elements/star.svg')" />
            <img id="upStarStroke-melody" :src="require('@/assets/congrats/melody-elements/upStarStroke.svg')" />
        </div>

        <h1 class='tamanhotitle titleCongrats-melody'>{{$t('games.congratulationsmessages.message'+ numero )}}</h1>

        <div class="button-style-congrats-melody">
            <span>{{$t('games.shared.home')}}</span>
            <span v-if="!gallery && userIsLoggedIn()">{{$t('games.shared.save_game')}}</span>
            <span v-if="!gallery">{{$t('games.shared.back_to_edit')}}</span>
            <span v-else>{{$t('games.shared.edit_again')}}</span>
        </div>
        <div class='button-list-style-melody'>
            <div class="tamanhoicon" @click="modal_open = !modal_open">
                <img :src="require('@/assets/buttons/newbuttons/melody/home.svg')" />
            </div>
            <div v-if="!gallery && userIsLoggedIn()" class="tamanhoicon" @click="$emit('saveGame')">
                <img :src="require('@/assets/buttons/newbuttons/melody/submit.svg')" />
            </div>
            <div class="tamanhoicon" @click="$emit('restart')">
                <img :src="require('@/assets/buttons/newbuttons/melody/restart.svg')" />
            </div>
        </div>

    </div>

    <FinalModal v-if="modal_open" @returnHome="
        current_screen = $emit('backToMenu');
        modal_open = !modal_open;
      " @closeModal="modal_open = !modal_open" @settings="
        current_screen = $emit('openSettings');
        modal_open = !modal_open;
      " />
</div>
</template>

<script>
import FinalModal from "@/components/MelodyGame/FinalModal.vue";

export default {

    name: "Congratulations",
    emits: ['restart', 'reDo', 'backToMenu', 'openSettings', 'saveGame'],
    components: {
        FinalModal,
    },
    data() {
        return {
            modal_open: false,
            current_screen: 'Congratulations',
            idFrase: '',
            displayFrase: '',
        };
    },
    created() {
        this.numero = Math.ceil(Math.random() * 4);
        console.log(this.numero);

    },
    props: {
        gallery: Boolean
    },
    methods: {}
}
</script>

<style>
.final-container-melody {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(78, 146, 105, 0.7);
    display: table;
    transition: opacity 0.3s ease;
}

.elements-melody {
    display: flex;
}

#bigcloud-melody {
    top: 10%;
    left: 26%;
    position: absolute;
}

#downStarFill-melody {
    position: absolute;
    top: 43%;
    left: 70%;
}

#mediumcloud-melody {
    top: 16%;
    left: 70%;
    position: absolute;
}

#smallcloud-melody {
    position: absolute;
    top: 21%;
    left: 15%;
}

#star-melody {
    position: absolute;
    top: 39%;
    left: 27%;
}

#upStarStroke-melody {
    position: absolute;
    top: 15%;
    left: 52%;
}

.button-style-congrats-melody {
    font-family: Omnes, sans-serif;
    font-size: 110%;
    color: white;
    position: absolute;
    left: 0;
    top: 52%;
    width: 79%;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-evenly;
    margin-left: 10%;
}

.button-list-style-melody {
    position: absolute;
    left: 0;
    top: 62%;
    width: 79%;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-evenly;
    margin-left: 10%;
}

.titleCongrats-melody {
    position: absolute;
    width: 100%;
    left: 0;
    top: 18%;
    font-family: Omnes;
    font-style: normal;
    font-weight: bold;
    line-height: 42px;
    text-align: center;
    color: white;
}

@media only screen and (max-width: 480px) {

    .button-list-style-melody>div {
        width: 2rem;
    }
}

@media only screen and (min-width: 480px) and (max-width: 550px) {

    .button-list-style-melody>div {
        width: 2.2rem;
    }
}

@media only screen and (min-width: 550px) and (max-width: 630px) {

    .button-list-style-melody>div {
        width: 2.4rem;
    }
}

@media only screen and (min-width: 630px) and (max-width: 718px) {

    .button-list-style-melody>div {
        width: 2.6rem;
    }
}

@media only screen and (min-width: 718px) and (max-width: 806px) {

    .button-list-style-melody>div {
        width: 2.8rem;
    }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {

    .button-list-style-melody>div {
        width: 3rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {

    .button-list-style-melody>div {
        width: 3.2rem;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {

    .button-list-style-melody>div {
        width: 3.4rem;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {

    .button-list-style-melody>div {
        width: 4rem;
    }

    #star-melody {
        width: 2.5rem;
    }

    #smallcloud-melody {
        width: 4rem;
    }

    #bigcloud-melody {
        width: 10rem;
    }

    #downStarFill-melody {
        width: 4rem;
    }

    #mediumcloud-melody {
        width: 6rem;
    }

    #upStarStroke-melody {
        width: 3rem;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {

    .button-list-style-melody>div {
        width: 4.4rem;
    }
}

@media only screen and (min-width: 1680px) and (max-width:2350px) {

    .button-list-style-melody>div {
        width: 4.8rem;
    }
}

@media only screen and (min-width: 2350px) {

    .button-list-style-melody>div {
        width: 4.8rem;
    }
}
</style>
